import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { ServiceSelect } from '../../selection'

interface AlertReassignDialogProps {
    open: boolean
    onClose: () => void
    alert: {
        id: number | string
        alertID: number
        summary: string
    }
    onSubmit: (newServiceID: string) => void | Promise<void>
    loading?: boolean
}

export default function AlertReassignDialog({
    open,
    onClose,
    alert,
    onSubmit,
    loading = false,
}: AlertReassignDialogProps): React.JSX.Element {
    const [serviceID, setServiceID] = useState<string | null>(null)

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        if (!serviceID) return
        await onSubmit(serviceID)
        setServiceID(null)
    }

    const handleClose = () => {
        if (!loading) {
            setServiceID(null)
            onClose()
        }
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Reassign Alert</DialogTitle>

            <form id="reassign-alert-form" onSubmit={handleSubmit}>
                <DialogContent>
                    <Typography variant="body2" color="textSecondary" sx={{ pb: 2 }}>
                        Alert #{alert.alertID}: {alert.summary}
                    </Typography>

                    <ServiceSelect
                        name="service_id"
                        label="Service"
                        value={serviceID || ''}
                        onChange={(val: string) => setServiceID(val)}
                        disabled={loading}
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} disabled={loading}>
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        form="reassign-alert-form"
                        variant="contained"
                        color="primary"
                        disabled={loading || !serviceID}
                    >
                        {loading ? 'Reassigning...' : 'Reassign'}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}
